export const DEFAULT_STRINGS = {
  'fab.label': 'Send feedback',
  'form.title': 'Send feedback',
  'form.description.label': 'What happened?',
  'form.description.placeholder': 'Describe the issue or idea in one or two sentences.',
  'form.type.label': 'Type',
  'form.severity.label': 'Severity',
  'form.submit': 'Send',
  'form.cancel': 'Cancel',
  'form.close': 'Close',
  'form.submitting': 'Sending…',
  'form.success': 'Thanks — your feedback was sent.',
  'form.error': 'Could not send. Please try again.',
  'form.description.required': 'Please describe the issue before sending.',
  'form.screenshot.label': 'Screenshot',
  'form.screenshot.cta_click': 'Click',
  'form.screenshot.cta_rest': 'drop, or paste an image',
  'form.screenshot.formats': 'PNG, JPEG or WebP — up to 10 MB',
  'form.screenshot.remove': 'Remove screenshot',
  'form.screenshot.annotate': 'Annotate',
  'form.screenshot.error_type': 'Unsupported file type. Use PNG, JPEG or WebP.',
  'form.screenshot.error_size': 'File too large (max {max} MB).',
  'form.context.label': 'Page',
  'type.bug': 'Bug',
  'type.feature': 'Feature request',
  'type.question': 'Question',
  'type.praise': 'Praise',
  'type.typo': 'Typo',
  'severity.blocker': 'Blocker',
  'severity.high': 'High',
  'severity.medium': 'Medium',
  'severity.low': 'Low',
  'annotator.title': 'Annotate screenshot',
  'annotator.tool.rectangle': 'Rectangle',
  'annotator.tool.arrow': 'Arrow',
  'annotator.tool.freehand': 'Freehand',
  'annotator.tool.text': 'Text',
  'annotator.tool.highlight': 'Highlight',
  'annotator.tool.blur': 'Blur (hide sensitive data)',
  'annotator.text_prompt': 'Enter text:',
  'annotator.color_picker': 'Custom color',
  'annotator.undo': 'Undo',
  'annotator.redo': 'Redo',
  'annotator.clear': 'Clear all',
  'annotator.count_suffix': 'annotations',
  'annotator.loading': 'Loading…',
  'annotator.apply': 'Apply',
  'annotator.applying': 'Applying…',
  'tab.send': 'Send',
  'tab.mine': 'My reports',
  'tab.changelog': 'This week',
  'tab.board': 'Board',
  'board.kpi.total': 'Total',
  'board.kpi.new': 'New',
  'board.kpi.in_progress': 'In progress',
  'board.kpi.awaiting_validation': 'Awaiting validation',
  'board.kpi.closed': 'Closed',
  'board.kpi.rejected': 'Rejected',
  'board.kpi.resolution_rate': 'Resolution rate',
  'board.sort': 'Sort',
  'board.sort.recent': 'Newest first',
  'board.sort.oldest': 'Oldest first',
  'board.sort.updated': 'Recently active',
  'board.sort.severity': 'Severity',
  'board.sort.status': 'Status',
  'board.filter.status': 'Status',
  'board.filter.type': 'Type',
  'board.filter.severity': 'Severity',
  'board.filter.search.placeholder': 'Search…',
  'board.filter.mine': 'Mine only',
  'board.filter.clear': 'Clear filters',
  'board.list.empty.title': 'Nothing here yet',
  'board.list.empty.description': 'When reports land, they’ll show up here.',
  'board.list.loading': 'Loading…',
  'board.list.error': 'Couldn’t load reports.',
  'board.retry': 'Try again',
  'board.list.you': 'you',
  'board.list.count': '{n} of {total}',
  'board.detail.empty': 'Pick a report on the left to see its full thread.',
  'board.detail.by': 'By',
  'board.detail.confirm_resolution': 'Confirm resolution',
  'board.detail.status_history': 'History',
  'board.scope.project': 'Project reports',
  'board.scope.mine': 'Your reports',
  'board.back': 'Back',
  'changelog.empty.title': 'Nothing resolved yet',
  'changelog.empty.body': 'Once a report you sent is fixed it will appear here, grouped by week.',
  'changelog.week_of': 'Week of {date}',
  'changelog.resolved_one': '{count} resolved',
  'changelog.resolved_many': '{count} resolved',
  'mine.empty.title': 'No reports yet',
  'mine.empty.body': 'Once you send feedback you can follow the thread here.',
  'mine.refresh': 'Refresh',
  'mine.loading': 'Loading…',
  'mine.error': 'Could not load your reports.',
  'mine.replies_one': '1 reply',
  'mine.replies_many': '{count} replies',
  'mine.filter.empty': 'No reports match this filter.',
  'kpi.new': 'New',
  'kpi.in_progress': 'In progress',
  'kpi.awaiting_validation': 'Awaiting you',
  'kpi.resolution_rate': 'Resolution rate',
  'detail.back': 'Back',
  'detail.thread': 'Conversation',
  'detail.no_replies': 'No replies yet — we’ll let you know when an operator responds.',
  'detail.compose_placeholder': 'Add a follow-up reply…',
  'detail.compose_send': 'Reply',
  'detail.compose_sending': 'Sending…',
  'detail.close_cta': 'Mark as resolved',
  'detail.close_busy': 'Marking…',
  'detail.reopen_cta': 'Still not fixed',
  'detail.reopen_busy': 'Reopening…',
  'detail.teammate_notice':
    'Viewing a teammate’s report — replies are private to the submitter.',
  'detail.load_failed.title': 'Report not available',
  'detail.load_failed.body':
    'It may have been deleted, or you no longer have access to it.',
  'detail.load_failed.cta': 'Back',
  'detail.send_failed': 'Couldn’t send your reply. Try again.',
  'detail.close_failed': 'Couldn’t mark as resolved. Try again.',
  'detail.reopen_failed': 'Couldn’t reopen the report. Try again.',
  'detail.history': 'Status history',
  'detail.context.submitted_at': 'Submitted',
  'detail.context.page': 'Page',
  'detail.context.capture.manual': 'Manual capture',
  'detail.context.capture.html2canvas': 'Auto capture',
  'detail.context.capture.display_media': 'Screen share',
  'detail.context.capture.none': 'No screenshot',
  'detail.author.staff': 'Operator',
  'detail.author.mcp': 'Mhosaic Team',
  'detail.author.system': 'System',
  'detail.tech.title': 'What we received',
  'detail.tech.errors_one': 'error',
  'detail.tech.errors_many': 'errors',
  'detail.tech.device': 'Device',
  'detail.tech.device.viewport': 'Viewport',
  'detail.tech.device.platform': 'Platform',
  'detail.tech.device.language': 'Language',
  'detail.tech.device.timezone': 'Timezone',
  'detail.tech.device.connection': 'Connection',
  'detail.tech.errors': 'Runtime errors',
  'detail.tech.console': 'Console (last 20)',
  'detail.tech.network': 'Network (last 15)',
  'status.new': 'New',
  'status.in_progress': 'In progress',
  'status.awaiting_validation': 'Awaiting your validation',
  'status.closed': 'Closed',
  'status.rejected': 'Rejected',
  'status.duplicate': 'Duplicate',
  'status.wontfix': 'Won’t fix',
}

export type StringKey = keyof typeof DEFAULT_STRINGS

const FRENCH_STRINGS: Record<StringKey, string> = {
  'fab.label': 'Envoyer un commentaire',
  'form.title': 'Envoyer un commentaire',
  'form.description.label': 'Qu’est-il arrivé ?',
  'form.description.placeholder': 'Décrivez le problème ou l’idée en une ou deux phrases.',
  'form.type.label': 'Type',
  'form.severity.label': 'Sévérité',
  'form.submit': 'Envoyer',
  'form.cancel': 'Annuler',
  'form.close': 'Fermer',
  'form.submitting': 'Envoi…',
  'form.success': 'Merci — votre commentaire a été envoyé.',
  'form.error': 'Échec d’envoi. Veuillez réessayer.',
  'form.description.required': 'Décrivez le problème avant d’envoyer.',
  'form.screenshot.label': 'Capture d’écran',
  'form.screenshot.cta_click': 'Cliquez',
  'form.screenshot.cta_rest': 'déposez ou collez une image',
  'form.screenshot.formats': 'PNG, JPEG ou WebP — jusqu’à 10 Mo',
  'form.screenshot.remove': 'Retirer la capture',
  'form.screenshot.annotate': 'Annoter',
  'form.screenshot.error_type': 'Format non supporté. Utilisez PNG, JPEG ou WebP.',
  'form.screenshot.error_size': 'Fichier trop volumineux (max {max} Mo).',
  'form.context.label': 'Page',
  'type.bug': 'Bogue',
  'type.feature': 'Suggestion',
  'type.question': 'Question',
  'type.praise': 'Compliment',
  'type.typo': 'Coquille',
  'severity.blocker': 'Bloquant',
  'severity.high': 'Élevée',
  'severity.medium': 'Moyenne',
  'severity.low': 'Faible',
  'annotator.title': 'Annoter la capture',
  'annotator.tool.rectangle': 'Rectangle',
  'annotator.tool.arrow': 'Flèche',
  'annotator.tool.freehand': 'Dessin libre',
  'annotator.tool.text': 'Texte',
  'annotator.tool.highlight': 'Surligner',
  'annotator.tool.blur': 'Flouter (données sensibles)',
  'annotator.text_prompt': 'Entrez le texte :',
  'annotator.color_picker': 'Couleur personnalisée',
  'annotator.undo': 'Annuler',
  'annotator.redo': 'Refaire',
  'annotator.clear': 'Tout effacer',
  'annotator.count_suffix': 'annotations',
  'annotator.loading': 'Chargement…',
  'annotator.apply': 'Appliquer',
  'annotator.applying': 'Application…',
  'tab.send': 'Envoyer',
  'tab.mine': 'Mes rapports',
  'tab.changelog': 'Cette semaine',
  'tab.board': 'Tableau',
  'board.kpi.total': 'Total',
  'board.kpi.new': 'Nouveau',
  'board.kpi.in_progress': 'En cours',
  'board.kpi.awaiting_validation': 'À valider',
  'board.kpi.closed': 'Fermé',
  'board.kpi.rejected': 'Refusé',
  'board.kpi.resolution_rate': 'Taux de résolution',
  'board.sort': 'Trier',
  'board.sort.recent': 'Plus récents',
  'board.sort.oldest': 'Plus anciens',
  'board.sort.updated': 'Activité récente',
  'board.sort.severity': 'Sévérité',
  'board.sort.status': 'Statut',
  'board.filter.status': 'Statut',
  'board.filter.type': 'Type',
  'board.filter.severity': 'Sévérité',
  'board.filter.search.placeholder': 'Rechercher…',
  'board.filter.mine': 'Les miens',
  'board.filter.clear': 'Effacer les filtres',
  'board.list.empty.title': 'Rien à voir ici',
  'board.list.empty.description': 'Les rapports apparaîtront ici dès qu’ils arrivent.',
  'board.list.loading': 'Chargement…',
  'board.list.error': 'Impossible de charger les rapports.',
  'board.retry': 'Réessayer',
  'board.list.you': 'vous',
  'board.list.count': '{n} sur {total}',
  'board.detail.empty': 'Sélectionnez un rapport à gauche pour voir le fil complet.',
  'board.detail.by': 'Par',
  'board.detail.confirm_resolution': 'Confirmer la résolution',
  'board.detail.status_history': 'Historique',
  'board.scope.project': 'Rapports du projet',
  'board.scope.mine': 'Vos rapports',
  'board.back': 'Retour',
  'changelog.empty.title': 'Rien de résolu pour l’instant',
  'changelog.empty.body': 'Quand un rapport que vous avez envoyé est corrigé, il apparaîtra ici, regroupé par semaine.',
  'changelog.week_of': 'Semaine du {date}',
  'changelog.resolved_one': '{count} résolu',
  'changelog.resolved_many': '{count} résolus',
  'mine.empty.title': 'Aucun rapport',
  'mine.empty.body': 'Après votre premier envoi vous pourrez suivre la conversation ici.',
  'mine.refresh': 'Actualiser',
  'mine.loading': 'Chargement…',
  'mine.error': 'Impossible de charger vos rapports.',
  'mine.replies_one': '1 réponse',
  'mine.replies_many': '{count} réponses',
  'mine.filter.empty': 'Aucun rapport ne correspond à ce filtre.',
  'kpi.new': 'Nouveau',
  'kpi.in_progress': 'En cours',
  'kpi.awaiting_validation': 'À valider',
  'kpi.resolution_rate': 'Taux de résolution',
  'detail.back': 'Retour',
  'detail.thread': 'Conversation',
  'detail.no_replies': 'Pas encore de réponse — vous serez notifié dès qu’un opérateur répondra.',
  'detail.compose_placeholder': 'Ajouter une réponse…',
  'detail.compose_send': 'Répondre',
  'detail.compose_sending': 'Envoi…',
  'detail.close_cta': 'Marquer comme résolu',
  'detail.close_busy': 'Validation…',
  'detail.reopen_cta': 'Toujours pas réglé',
  'detail.reopen_busy': 'Réouverture…',
  'detail.teammate_notice':
    'Vous consultez le rapport d’un coéquipier — les réponses sont privées au soumetteur.',
  'detail.load_failed.title': 'Rapport indisponible',
  'detail.load_failed.body':
    'Il a peut-être été supprimé, ou vous n’y avez plus accès.',
  'detail.load_failed.cta': 'Retour',
  'detail.send_failed': 'Impossible d’envoyer votre réponse. Réessayez.',
  'detail.close_failed':
    'Impossible de marquer comme résolu. Réessayez.',
  'detail.reopen_failed':
    'Impossible de rouvrir le rapport. Réessayez.',
  'detail.history': 'Historique du statut',
  'detail.context.submitted_at': 'Envoyé',
  'detail.context.page': 'Page',
  'detail.context.capture.manual': 'Capture manuelle',
  'detail.context.capture.html2canvas': 'Capture automatique',
  'detail.context.capture.display_media': 'Partage d’écran',
  'detail.context.capture.none': 'Sans capture',
  'detail.author.staff': 'Opérateur',
  'detail.author.mcp': 'Équipe Mhosaic',
  'detail.author.system': 'Système',
  'detail.tech.title': 'Ce que nous avons reçu',
  'detail.tech.errors_one': 'erreur',
  'detail.tech.errors_many': 'erreurs',
  'detail.tech.device': 'Appareil',
  'detail.tech.device.viewport': 'Fenêtre',
  'detail.tech.device.platform': 'Plateforme',
  'detail.tech.device.language': 'Langue',
  'detail.tech.device.timezone': 'Fuseau horaire',
  'detail.tech.device.connection': 'Connexion',
  'detail.tech.errors': 'Erreurs d’exécution',
  'detail.tech.console': 'Console (20 derniers)',
  'detail.tech.network': 'Réseau (15 derniers)',
  'status.new': 'Nouveau',
  'status.in_progress': 'En cours',
  'status.awaiting_validation': 'En attente de validation',
  'status.closed': 'Fermé',
  'status.rejected': 'Rejeté',
  'status.duplicate': 'Doublon',
  'status.wontfix': 'Non corrigé',
}

const LOCALE_PACKS: Record<string, Record<StringKey, string>> = {
  fr: FRENCH_STRINGS,
}

interface ResolveOptions {
  locale?: string
}

function packFor(locale: string | undefined): Record<StringKey, string> | null {
  if (!locale) return null
  // Match the language subtag only (fr-CA, fr-FR → fr).
  const tag = locale.toLowerCase().split(/[-_]/)[0]!
  return LOCALE_PACKS[tag] ?? null
}

export function resolveStrings(
  overrides: Record<string, string>,
  options: ResolveOptions = {},
): Record<StringKey, string> {
  const localePack = packFor(options.locale) ?? {}
  return {
    ...DEFAULT_STRINGS,
    ...localePack,
    ...overrides,
  } as Record<StringKey, string>
}
